// distance in px => if less than this distance, modules are considered dense
export const MARKER_DENSITY_DISTANCE = 70

// Returns the map canvas size in pixels at a given zoom level
const worldSize = (zoom) => 256 * 2 ** zoom

// Converts geographic coordinates to Web Mercator pixel coordinates at the given zoom level
const project = ({ lat, lng }, zoom) => {
  const size = worldSize(zoom)
  const sin = Math.sin((lat * Math.PI) / 180)

  return {
    x: ((lng + 180) / 360) * size,
    y:
      (0.5 -
        Math.log(
          (1 + Math.min(Math.max(sin, -0.9999), 0.9999)) /
            (1 - Math.min(Math.max(sin, -0.9999), 0.9999))
        ) /
          (4 * Math.PI)) *
      size,
  }
}

// Returns IDs of modules that have another module within pixelDistance.
// A spatial grid keeps this linear for the usual project sizes.
export const getDenseModuleIds = (
  modules,
  zoom,
  pixelDistance = MARKER_DENSITY_DISTANCE
) => {
  if (zoom == null || !modules?.length || pixelDistance <= 0) return new Set()

  const cellSize = pixelDistance
  const distanceSquared = pixelDistance ** 2
  const points = modules.map((module) => ({
    id: module.id,
    ...project(module, zoom),
  }))
  const grid = new Map()
  const denseIds = new Set()
  const size = worldSize(zoom)

  points.forEach((point) => {
    const cellX = Math.floor(point.x / cellSize)
    const cellY = Math.floor(point.y / cellSize)
    for (let x = cellX - 1; x <= cellX + 1; x += 1) {
      for (let y = cellY - 1; y <= cellY + 1; y += 1) {
        const wrappedX = Math.ceil(worldSize(zoom) / cellSize)
        const candidateX = x < 0 ? wrappedX - 1 : x >= wrappedX ? 0 : x
        const candidates = grid.get(`${candidateX}:${y}`) || []
        candidates.forEach((candidate) => {
          const dx = Math.min(
            Math.abs(point.x - candidate.x),
            size - Math.abs(point.x - candidate.x)
          )
          const dy = point.y - candidate.y
          if (dx * dx + dy * dy <= distanceSquared) {
            denseIds.add(point.id)
            denseIds.add(candidate.id)
          }
        })
      }
    }

    const key = `${cellX}:${cellY}`
    grid.set(key, [...(grid.get(key) || []), point])
  })

  return denseIds
}
